import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import './Auth.css';

function VerifyCode() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const phone = searchParams.get('phone');
  
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!phone) {
      // Если нет номера телефона в URL, редирект на регистрацию
      navigate('/signup', { replace: true });
    }
  }, [phone, navigate]);

  const handleCodeChange = (e) => {
    const value = e.target.value.toUpperCase();
    if (value.length <= 8) {
      setCode(value);
      setError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (code.length !== 8) {
      setError('Код должен содержать 8 символов');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch('/api/v1/auth/telegram/verify-code', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: code.toUpperCase() })
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('access_token', data.access_token);
        localStorage.setItem('refresh_token', data.refresh_token);
        localStorage.setItem('user_data', JSON.stringify(data.user));
        localStorage.setItem('markapp_onboarding_seen', 'true');
        localStorage.setItem('markapp_onboarding_completed', 'true');

        

        setTimeout(() => {
          navigate('/', { replace: true });
        }, 500);
      } else {
        if (response.status === 401) {
          setError('Неверный код. Проверьте код в Telegram.');
        } else {
          setError(data.detail || 'Ошибка проверки кода');
        }
      }
    } catch (err) {
      console.error('Verify error:', err);
      setError('Ошибка соединения с сервером');
    } finally {
      setLoading(false);
    }
  };

  const formatPhone = (phoneNumber) => {
    if (!phoneNumber) return '';
    const digits = phoneNumber.replace(/\D/g, '');
    if (digits.length === 11 && digits.startsWith('7')) {
      return `+7 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
    }
    return phoneNumber;
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-side">
          <div className="auth-side-content">
            <a href="https://markapp.pro" className="auth-logo">
              <img src="/markapp-logo-white.png" alt="MarkApp" className="auth-logo-image" />
            </a>

            <h1 className="auth-side-title">Почти готово!</h1>
            <p className="auth-side-description">
              Откройте Telegram бот и поделитесь номером телефона, чтобы получить код подтверждения
            </p>

            <div className="auth-benefits">
              <div className="benefit-item">
                <div className="benefit-icon">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16.64 8.8C16.49 10.38 15.84 14.22 15.51 15.99C15.37 16.74 15.09 16.99 14.82 17.02C14.25 17.07 13.81 16.64 13.25 16.27C12.37 15.69 11.87 15.33 11.02 14.77C10.03 14.12 10.67 13.76 11.24 13.18C11.39 13.03 13.95 10.7 14 10.49C14.01 10.46 14.01 10.36 13.95 10.31C13.89 10.26 13.81 10.28 13.74 10.29C13.65 10.31 12.25 11.24 9.52 13.08C9.12 13.35 8.76 13.49 8.44 13.48C8.08 13.47 7.4 13.28 6.89 13.11C6.26 12.91 5.77 12.8 5.81 12.45C5.83 12.27 6.08 12.09 6.55 11.9C9.47 10.63 11.41 9.79 12.38 9.39C15.16 8.23 15.73 8.03 16.11 8.03C16.19 8.03 16.38 8.05 16.5 8.15C16.6 8.23 16.63 8.34 16.64 8.42C16.63 8.48 16.65 8.66 16.64 8.8Z" fill="white"/>
                  </svg>
                </div>
                <div className="benefit-text">
                  <div className="benefit-title">Шаг 1</div>
                  <div className="benefit-desc">Откройте @markapper_bot</div>
                </div>
              </div>
              <div className="benefit-item">
                <div className="benefit-icon">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="6" y="2" width="12" height="20" rx="2" stroke="white" strokeWidth="2" fill="rgba(255,255,255,0.15)"/>
                    <path d="M10 5H14" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                    <circle cx="12" cy="18" r="1.5" fill="white"/>
                  </svg>
                </div>
                <div className="benefit-text">
                  <div className="benefit-title">Шаг 2</div>
                  <div className="benefit-desc">Поделитесь номером</div>
                </div>
              </div>
              <div className="benefit-item">
                <div className="benefit-icon">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 12L11 14L15 10" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="white" strokeWidth="2"/>
                  </svg>
                </div>
                <div className="benefit-text">
                  <div className="benefit-title">Шаг 3</div>
                  <div className="benefit-desc">Введите код</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="auth-form-panel">
          <div className="auth-form-container">
            <div className="auth-header">
              <h2 className="auth-title">Введите код подтверждения</h2>
              <p style={{ fontSize: '14px', color: '#6c757d', marginTop: '8px' }}>
                Номер телефона: <strong>{formatPhone(phone)}</strong>
              </p>
            </div>

            <div className="code-sent-message">
              <div className="message-icon">📱</div>
              <div className="message-content">
                <div className="message-title">Откройте Telegram бот</div>
                <div className="message-text">
                  Откройте <strong>@markapper_bot</strong> в Telegram, нажмите <strong>/start</strong> и поделитесь номером телефона, чтобы получить 8-значный код
                </div>
              </div>
            </div>

            <a 
              href="https://t.me/markapper_bot" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-secondary"
              style={{ marginBottom: '20px' }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16.64 8.8C16.49 10.38 15.84 14.22 15.51 15.99C15.37 16.74 15.09 16.99 14.82 17.02C14.25 17.07 13.81 16.64 13.25 16.27C12.37 15.69 11.87 15.33 11.02 14.77C10.03 14.12 10.67 13.76 11.24 13.18C11.39 13.03 13.95 10.7 14 10.49C14.01 10.46 14.01 10.36 13.95 10.31C13.89 10.26 13.81 10.28 13.74 10.29C13.65 10.31 12.25 11.24 9.52 13.08C9.12 13.35 8.76 13.49 8.44 13.48C8.08 13.47 7.4 13.28 6.89 13.11C6.26 12.91 5.77 12.8 5.81 12.45C5.83 12.27 6.08 12.09 6.55 11.9C9.47 10.63 11.41 9.79 12.38 9.39C15.16 8.23 15.73 8.03 16.11 8.03C16.19 8.03 16.38 8.05 16.5 8.15C16.6 8.23 16.63 8.34 16.64 8.42C16.63 8.48 16.65 8.66 16.64 8.8Z" fill="currentColor"/>
              </svg>
              Открыть @markapper_bot
            </a>

            <form onSubmit={handleSubmit} className="auth-form" noValidate>
              <div className="form-group">
                <label htmlFor="code" className="form-label">
                  Код из Telegram <span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="code"
                  name="code"
                  className="form-input code-input"
                  placeholder="ABC12345"
                  value={code}
                  onChange={handleCodeChange}
                  required
                  maxLength={8}
                  style={{ textAlign: 'center', fontSize: '24px', letterSpacing: '4px' }}
                />
                {error && <div className="form-error show">{error}</div>}
              </div>

              <button 
                type="submit" 
                className={`btn-primary btn-block btn-auth ${loading ? 'loading' : ''}`} 
                disabled={loading || code.length !== 8}
              >
                <span className="btn-text">Подтвердить</span>
                {loading && (
                  <span className="btn-loader">
                    <svg className="spinner" width="20" height="20" viewBox="0 0 20 20">
                      <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="2" fill="none" strokeDasharray="50" strokeDashoffset="25"/>
                    </svg>
                  </span>
                )}
              </button>

              <div className="auth-switch">
                Уже есть код? Введите его выше
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyCode;

